import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import './ResetPassword.css';

const API_URL = process.env.REACT_APP_API_URL;

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(`${API_URL}/api/users/reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, newPassword }),
    });
    const data = await response.json();
    if (response.ok) setMessage("Password reset successful!");
    else setMessage(data.error || "Something went wrong.");
  };

  return (
    <div className="resetpassword-module">
      <h2>Reset Password</h2>
      <form onSubmit={handleSubmit} className="resetpassword-form" >
        <input className="form-input"
          type="password"
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)}
          placeholder="Enter your new password"
          required
        />
        <button type="submit">Reset Password</button>
      </form>
      {message && <div>{message}</div>}
    </div>
  );
}

export default ResetPassword;
